import { translations } from "./translations";

class I18n {
  constructor() {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      this.currentLanguage = storedLanguage;
    } else {
      this.currentLanguage = this.detectSystemLanguage();
      // Store the detected language for consistency
      localStorage.setItem("language", this.currentLanguage);
    }
    this.translations = {};
    this.init();
  }

  detectSystemLanguage() {
    const supportedLanguages = ["en", "de", "ro"];
    let browserLanguage = null;

    // Try to get language from navigator.languages (preferred) or navigator.language
    if (navigator.languages && navigator.languages.length > 0) {
      browserLanguage = navigator.languages[0];
    } else if (navigator.language) {
      browserLanguage = navigator.language;
    }

    if (browserLanguage) {
      // Extract language code (e.g., "ro-RO" → "ro", "en-US" → "en")
      const languageCode = browserLanguage.split("-")[0].toLowerCase();
      
      // Check if the language is supported
      if (supportedLanguages.includes(languageCode)) {
        return languageCode;
      }
    }

    // Default to English if no supported language is detected
    return "en";
  }

  async init() {
    await this.loadTranslations();
    this.translatePage();
    this.updateHtmlLang();
    this.initializeLanguageSelector();
  }

  async loadTranslations() {
    try {
      if (!translations[this.currentLanguage]) {
        console.error(`Translations not found for language: ${this.currentLanguage}`);
        console.log("Available languages:", Object.keys(translations));
        // Fallback to English if language not found
        this.currentLanguage = "en";
        this.translations = translations[this.currentLanguage];
      } else {
        this.translations = translations[this.currentLanguage];
      }
    } catch (error) {
      console.error("Error loading translations:", error);
      // Fallback to English on error
      this.currentLanguage = "en";
      this.translations = translations[this.currentLanguage];
    }
  }

  translatePage() {
    const elements = document.querySelectorAll("[data-i18n]");

    elements.forEach((element) => {
      const key = element.getAttribute("data-i18n");
      const [namespace, ...pathParts] = key.split(".");
      const path = pathParts.join(".");
      const namespaceTranslations = this.translations[namespace];
      const translation = this.getNestedTranslation(
        namespaceTranslations,
        path
      );

      if (translation) {
        if (element.classList.contains("scramble-text")) {
          element.textContent = translation;
          if (window.initScrambleText) {
            window.initScrambleText();
          }
        } else {
          element.textContent = translation;
        }
      }
    });
  }

  getNestedTranslation(obj, path) {
    if (!obj || !path) return undefined;
    return path
      .split(".")
      .reduce((p, c) => (p && typeof p === "object" ? p[c] : undefined), obj);
  }

  updateHtmlLang() {
    document.documentElement.lang = this.currentLanguage;
  }

  initializeLanguageSelector() {
    const selector = document.getElementById("languageSelect");
    if (selector) {
      selector.value = this.currentLanguage;
    }
  }

  async changeLanguage(lang) {
    this.currentLanguage = lang;
    localStorage.setItem("language", lang);
    await this.loadTranslations();
    this.translatePage();
    this.updateHtmlLang();

    // Dispatch language change event
    document.dispatchEvent(new Event("languageChanged"));
  }
}

const i18n = new I18n();
window.changeLanguage = async (lang) => await i18n.changeLanguage(lang);
